import React from 'react';
import { cn } from '@/utils';
import { ITableColumn } from './Table.types';

interface TableSkeletonProps {
  /** Array of columns to determine skeleton structure */
  columns: ITableColumn[];
  /** Number of skeleton rows to show */
  rows?: number;
}

/**
 * TableSkeleton Component
 *
 * Shows a loading skeleton while table data is being fetched.
 */
export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  rows = 5,
}) => {
  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <tr
          key={rowIndex}
          className="border-b border-neutral-gray-300 last:border-b-0"
        >
          {columns.map((column, colIndex) => (
            <td
              key={`${rowIndex}-${colIndex}`}
              className="px-0 py-2 pr-4 h-[72px] align-middle"
              style={column.width ? { 
                width: typeof column.width === 'number' 
                  ? `${column.width}px` 
                  : column.width,
                minWidth: typeof column.width === 'number' 
                  ? `${column.width}px` 
                  : column.width 
              } : { minWidth: 'max-content' }}
            >
              <div className="flex flex-col gap-1">
                <div className="h-4 bg-neutral-gray-200 rounded animate-pulse" />
                {/* {colIndex === 0 && (
                  <div className="h-3 bg-neutral-gray-100 rounded animate-pulse w-3/4" />
                )} */}
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

TableSkeleton.displayName = 'TableSkeleton';